/* eslint-disable */


/**
 * Create styles for `<OrderConfirmationDialog />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderConfirmationDialog />` styles
 */
const orderConfirmationDialogStyles = ({ theme }) => ({
  confirmationLabel: {
    marginBottom: theme.spacing(1) * 2,
    marginTop: theme.spacing(1) * 2,
  },
  ctaButtons: {
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    height: theme.spacing(1) * 7,
  },
});

export default orderConfirmationDialogStyles;
